import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { User } from 'firebase/auth';

import { ROLES_QUERY_KEY, ROLE_API_URL } from '@/constants';
import { apiUrl } from '@/helpers';

export const roleEndpoints = {
  getAll: () => axios.get(`${apiUrl()}${ROLE_API_URL}/all`),
  getRoles: () => axios.get(`${apiUrl()}${ROLE_API_URL}`)
};

export const useGetAllRoles = () => {
  return useQuery([ROLES_QUERY_KEY], roleEndpoints.getAll);
};

export const useGetRoles = (currentUser?: User | null) => {
  return useQuery([ROLES_QUERY_KEY], roleEndpoints.getRoles, {
    enabled: !!currentUser
  });
};
